export type LedgerRow = {
  id: string;
  kind: string;
  credits: number;
  balance_after: number;
  job_kind: string | null;
  created_at: string;
  metadata: Record<string, unknown> | null;
};

export const KIND_LABEL: Record<string, string> = {
  monthly_grant: "Monthly grant",
  topup_purchase: "Top-up purchase",
  consumption: "Used",
  adjustment: "Adjustment",
  refund: "Refund",
};

export const ADMIN_GRANT_CATEGORY_LABEL: Record<string, string> = {
  customer_service: "Customer service credit from Excerptus",
  thank_you: "Thank-you from Excerptus",
  gift: "Gift from Excerptus",
  promo: "Promotional credit from Excerptus",
  other: "Credit from Excerptus",
};

/**
 * Pure label builder so the test suite can verify every metadata shape
 * without standing up React Query.
 */
export function labelForRow(row: Pick<LedgerRow, "kind" | "job_kind" | "metadata">): string {
  if (row.kind === "consumption" && row.job_kind) {
    return `Used for ${row.job_kind.replace(/_/g, " ")}`;
  }
  if (row.kind === "adjustment") {
    const meta = row.metadata ?? {};
    const metaKind = (meta as { kind?: string }).kind;
    if (metaKind === "admin_grant") {
      const category = (meta as { category?: string }).category ?? "other";
      return ADMIN_GRANT_CATEGORY_LABEL[category] ?? ADMIN_GRANT_CATEGORY_LABEL.other;
    }
    if (metaKind === "admin_grant_reversal") {
      return "Grant reversed";
    }
  }
  return KIND_LABEL[row.kind] ?? row.kind;
}
